import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const listDefaultVariants = {
  "size": "md",
  "isSelected": false
}
const listCompoundVariants = []

const listSlotNames = [
  [
    "root",
    "List__root"
  ],
  [
    "item",
    "List__item"
  ],
  [
    "icon",
    "List__icon"
  ],
  [
    "action",
    "List__action"
  ],
  [
    "subHeader",
    "List__subHeader"
  ],
  [
    "divider",
    "List__divider"
  ],
  [
    "addon",
    "List__addon"
  ]
]
const listSlotFns = /* @__PURE__ */ listSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, listDefaultVariants, getSlotCompoundVariant(listCompoundVariants, slotName))])

const listFn = memo((props = {}) => {
  return Object.fromEntries(listSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const listVariantKeys = [
  "size",
  "isSelected"
]
const getVariantProps = (variants) => ({ ...listDefaultVariants, ...compact(variants) })

export const list = /* @__PURE__ */ Object.assign(listFn, {
  __recipe__: false,
  __name__: 'list',
  raw: (props) => props,
  variantKeys: listVariantKeys,
  variantMap: {
  "size": [
    "sm",
    "md"
  ],
  "isSelected": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, listVariantKeys)
  },
  getVariantProps
})